/*
  Hide unselected variant images (ported from the Horizon theme).
  Slides and thumbs marked data-variant-image belong to a variant; they are only shown while
  that variant is selected. If the selected variant has no image of its own, everything shows.
  The product form fires theme:variant:change before it scrolls to the variant image, so the
  slide is visible by the time the theme looks for it.
*/
(function () {
  var toArray = function (list) { return Array.prototype.slice.call(list || []); };

  function mediaIdOf(el) {
    if (el.hasAttribute('data-image-id')) return el.getAttribute('data-image-id');
    var link = el.querySelector('[data-media-id]');
    if (!link) return '';
    var parts = link.getAttribute('data-media-id').split('-');
    return parts[parts.length - 1];
  }

  function apply(container, variant) {
    var selectedId = variant && variant.featured_media ? String(variant.featured_media.id) : '';
    var items = toArray(container.querySelectorAll('.product__slide[data-image-id], [data-thumb-item]'));
    var slides = [];

    items.forEach(function (el) {
      var isVariantImage = el.hasAttribute('data-variant-image');
      var hidden = !!selectedId && isVariantImage && mediaIdOf(el) !== selectedId;
      if (hidden) el.setAttribute('data-variant-hidden', ''); else el.removeAttribute('data-variant-hidden');
      if (el.hasAttribute('data-image-id')) {
        el.classList.remove('media--first-visible', 'media--last-visible');
        if (!hidden) slides.push(el);
      }
    });

    if (slides.length) {
      slides[0].classList.add('media--first-visible');
      slides[slides.length - 1].classList.add('media--last-visible');
    }
  }

  document.addEventListener('theme:variant:change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var container = target.closest('[data-hide-variant-media]');
    if (!container) return;
    apply(container, e.detail && e.detail.variant);
  });
})();
